<template>
  <b-row>
    <b-col>
      <div class="p-4">
        <div class="showcase-header mb-5">
          <h3 class="showcase-title mb-3 mb-md-0">{{title}}</h3>
          <router-link :to="route" class="showcase-btn">VIEW ALL</router-link>
        </div>
        <slick :options="slickOptions" v-if="popularProducts.length > 0">
          <RecommendationCard
            v-for="(popularProduct, index) in popularProducts"
            :key="index"
            :product="popularProduct"
          />
        </slick>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import RecommendationCard from "../../components/RecommendationCard";
import Slick from "vue-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

export default {
  name: "ProductShowCase",
  components: {
    RecommendationCard,
    Slick,
  },
  props: ["title", "route"],
  mounted() {
    this.$axios.get("popular-products").then((res) => {
      if (res.data.type && res.data.type == "success") {
        this.popularProducts = res.data.data;
      }
    });
  },
  data() {
    return {
      popularProducts: {},
      slickOptions: {
        slidesToShow: 3,
        slidesToScroll: 6,
        infinite: true,
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.showcase-header {
  width: 100%;
  justify-content: space-between;
  display: flex;
}

@media screen and (max-width: 768px) {
  .showcase-header {
    display: block;
    text-align: center;
  }
}
.showcase-title {
  align-self: flex-start;
  margin: 0;
}

.showcase-btn {
  /* float: right; */
  vertical-align: middle;
  padding: 5px 10px;
  font-weight: bold;
  color: black;
  text-decoration: none;
  border-width: 1px;
  border-style: solid;
  border-color: initial;
  letter-spacing: 0.2px;
  margin-left: 10px;
  border-color: black;
}
</style>